import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operation-events-form',
  templateUrl: './operation-events-form.component.html',
  styleUrls: ['./operation-events-form.component.scss']
})
export class OperationEventsFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
